import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DEFAULT_PROFILE_IMAGE_URL,
  UserAvatar,
} from '../../components/UserProfiles/UserAvatar';
import { LeaderboardEntry as LeaderboardEntryType } from './LeaderboardTypes';
import { PROFILE_PATH } from '../../pathNames';
import {
  EntryContainer,
  RankNumber,
  UserInfo,
  UserName,
  UserScore,
} from './LeaderboardStyles';
import { BiUpvote } from 'react-icons/bi';

interface LeaderboardEntryProps {
  entry: LeaderboardEntryType;
  position: number;
}

const LeaderboardEntry: React.FC<LeaderboardEntryProps> = ({
  entry,
  position,
}) => {
  const { userId, profileImageUrl, displayName, score, sharedImageUrl } = entry;
  const navigate = useNavigate();

  const handleGoToProfile = () => {
    userId && navigate(`${PROFILE_PATH}/${userId}`);
  };

  const urlToUse = profileImageUrl || sharedImageUrl || DEFAULT_PROFILE_IMAGE_URL;

  return (
    <EntryContainer onClick={handleGoToProfile}>
      <RankNumber>{position}</RankNumber>
      <UserAvatar
        url={urlToUse}
        imageDetailVariant={true}
      />
      <UserInfo>
        <UserName>{displayName || 'Anonymous'}</UserName>
        <UserScore><BiUpvote /> {score}</UserScore>
      </UserInfo>
    </EntryContainer>
  );
};

export default LeaderboardEntry;
